import { Suspense } from 'react'
import { Routes } from 'react-router'

import Loading from '@/components/generics/Loading'

import { default as PublicRoutes } from './public.routes'
import { default as PrivateRoutes } from './private.routes'
import RouterStoreProvider from '@/contexts/router'

export default (
  <Suspense fallback={<Loading />}>
    <RouterStoreProvider>
      <Routes>
        {PublicRoutes}
        {PrivateRoutes}
      </Routes>
    </RouterStoreProvider>
  </Suspense>
)
